import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const OnairToggleButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { isOnair, setOnair, reloadUserScreens } = rootStore.screensStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = async () => {
    const newValue = !isOnair;
    setOnair(newValue);
    await reloadUserScreens();
  };

  return (
    <>
      <Button
        id="select"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          `${theme!.toolbarIconColor}`
        )}
        color=""
        onClick={async () => await handleClick()}
        style={{ position: "relative" }}
      >
        {isOnair ? (
          <i className="fas fa-toggle-on iconToolbarButton text-green"></i>
        ) : (
          <i className="fas fa-toggle-off iconToolbarButton"></i>
        )}

        <h6 className="textToolbarButton mb-0">{t("toolbar_onair_toggle")}</h6>
      </Button>
    </>
  );
};

export default observer(OnairToggleButton);
